// extracted by mini-css-extract-plugin
export default {"projectsPage":"Projects_projectsPage__QLdub"};